export const version = {
    appVersion: '3.1.2',
    buildDate: '2026-5-6 16:52:54'
}
